import React from 'react'
import BattleForm from './BattleForm';
import PokemonList from './PokemonList';
import PokemonForm from './PokemonForm';
import BattleList from './BattleList';
import PokemonListAPI from './PokemonListAPI';
import { Row, Col, Tabs } from 'antd';

function Home() {
    return (
        <Row>
            <Col span={2}></Col>
            <Col span={20}>
                <Tabs defaultActiveKey="1">
                    <Tabs.TabPane tab="Details" key="1">
                        <PokemonForm />
                        <PokemonList />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Battles" key="2">
                        <BattleForm />
                        <BattleList />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab="Pokemon API" key="3">
                        <PokemonListAPI />
                    </Tabs.TabPane>
                </Tabs>
            </Col>
        </Row>
    )
}

export default Home